import { Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { apiClient } from '../../../services/api_client';
import ContentTitle from '../../layout/ContentTitle/ContentTitle';
import Observer from '../../shared/Observer/Observer';
import NewsCard from '../NewsCard/NewsCard';
import { PAGE } from '../../../constants/page';
import ArrowButton from '../../ui/ArrowButton/ArrowButton';

interface Props {
  children?: React.ReactElement<unknown>;
}

const texts = [
  "サプライムの新着情報はこちらからご覧いただけます。"
]

export default function NewsSection(props: Props) {
  /** 読み込み中判定 */
  const [isLoading, setIsLoading] = useState<boolean>(true)
  /** お知らせリスト */
  const [newses, setNewses] = useState<Array<News>>([])
  /** 1ページに表示する件数 */
  const [count, setCount] = useState(3)

  useEffect(() => {
    // お知らせ取得API
    const fetchData = async () => {
      // クエリパラメータ設定
      const queryParams: Array<Array<string>> = [["limit", String(count)]]
      // プレビューモードを絞り込み
      if (process.env.REACT_APP_NEWS_PREVIEW_MODE === 'false') queryParams.push(["filters", "preview[equals]false"])
      // 管理画面デフォルトの表示順でソート
      queryParams.push(["orders", "system:default"])
      const getNews = await apiClient.getNews({
        // mock: 'GetNews.json'
        queryParams: queryParams,
      }).finally(() => {
        setIsLoading(false)
      })
      // お知らせを設定
      setNewses(getNews.contents)
    }

    // お知らせ取得処理
    fetchData()
  }, [])

  return (
    <>
      <Grid container>
        <Grid size={{ sm: 12, lg: 12 }}>
          <Observer>
            <ContentTitle title={PAGE.NEWS.NAME} subTitle={PAGE.NEWS.TEXT} />
          </Observer>
        </Grid>

        <Grid size={{ md: 12, lg: 12 }} sx={{ padding: '2rem 0.5rem' }}>
          {texts.map((t, index) => {
            return (
              <Observer key={index} timeout={(index + 1) * 100}>
                <Typography
                  variant="body2"
                  sx={(theme) => ({
                    [theme.breakpoints.up('xs')]: {
                      fontSize: '1.1rem',
                    },
                    [theme.breakpoints.up('sm')]: {
                      fontSize: '1.2rem',
                    },
                    [theme.breakpoints.up('md')]: {
                      fontSize: '1.25rem',
                    },
                    [theme.breakpoints.up('lg')]: {
                      fontSize: '1.5rem',
                    },
                  })}
                >
                  {t}
                </Typography>
              </Observer>
            )
          })}
        </Grid>

        <Grid size={{ sm: 12, lg: 12 }}>
          <Grid container spacing={2}>
            {isLoading ?
              (
                <>
                  <Grid size={{ xs: 12, sm: 12, md: 4 }} sx={{ padding: '1rem' }}>
                    <Observer timeout={1 * 250}>
                      <NewsCard isLoading={true} />
                    </Observer>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12, md: 4 }} sx={{ padding: '1rem' }}>
                    <Observer timeout={2 * 250}>
                      <NewsCard isLoading={true} />
                    </Observer>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12, md: 4 }} sx={{ padding: '1rem' }}>
                    <Observer timeout={3 * 250}>
                      <NewsCard isLoading={true} />
                    </Observer>
                  </Grid>
                </>
              )
              :
              newses.length ?
                newses.map((news, index) => {
                  return (
                    <Grid key={index} size={{ xs: 12, sm: 12, md: 4 }} sx={{ padding: '0.5rem 0' }}>
                      <Observer timeout={(index + 1) * 250}>
                        <NewsCard news={news} />
                      </Observer>
                    </Grid>
                  )
                })
                :
                <Grid size={{ sm: 12 }} sx={{ padding: '1.5rem' }}>
                  <Observer timeout={500}>
                    <Typography variant="body2" component="p" fontSize={'1.25rem'} padding={'2rem'} >
                      {'現在お知らせはありません。'}
                    </Typography>
                  </Observer>
                </Grid>
            }
          </Grid>
        </Grid>
      </Grid>

      <Grid size={{ sm: 12, lg: 12 }} sx={{ textAlign: 'right', padding: '1rem' }}>
        <Observer timeout={3 * 500}>
          <ArrowButton label="MORE" href={PAGE.NEWS.PATH} />
        </Observer>
      </Grid>
    </ >
  )
}